<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryVolumesByGroupIdList" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="actions">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="volumeDelmodal = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <br>

        <Modal v-model="volumeDelmodal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{volumeName}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long  @click="deleteVolume()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
    </div>

</template>
<script>
    var tableVolumes = {}
    export default {
        name: 'TableVolumes',
        data () {
            return {
                volumeName: '',
                modalLoading: true,
                volumeDelmodal: false,
                isDisable: false,
                columns: [
                {
                    title: this.$t('RAM.AWS.computeInstance.instanceID'),
                    key: 'instanceId'
                },
                {
                    title: this.$t('alarms.disk.diskId'),
                    key: 'volumeAwsId'
                },
                {
                    title: this.$t('alarms.disk.name'),
                    key: 'name'
                },
                {
                    title: this.$t('alarms.disk.deviceName'),
                    key: 'deviceName'
                },
                {
                    title: this.$t('alarms.disk.capacity'),
                    key: 'capacity'
                },
                {
                    title: this.$t('alarms.disk.type'),
                    key: 'type'
                },
                {
                    title: this.$t('alarms.disk.iops'),
                    key: 'iops'
                },
                 {
                    title: this.$t('alarms.disk.encrypted'),
                    key: 'encrypted'
                },
                {
                    title: this.$t('alarms.disk.region'),
                    key: 'region'
                },
                {
                    title: this.$t('alarms.disk.state'),
                    key: 'stateName'
                },
                {
                  title: this.$t('common.operation'),
                  slot: 'actions'
                }],
                queryVolumesByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableVolumes = this
        },
        mounted: function () {
            tableVolumes.queryVolumesByGroupId();
        },
        methods: {
            queryVolumesByGroupId: function () {
                tableVolumes.$api.alertRuleExceptionResource.listAlertRuleExceptionResource({
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id,
                    "monitorModule": this.$route.query.monitorModule
                })
                .then(res => {
                    this.modalLoading = false
                    if(res.data){
                        this.queryVolumesByGroupIdList = res.data;
                    }else{
                        this.queryVolumesByGroupIdList=[];
                    }
                })
            },
            // 显示所有数据
            showAllVolume: function () {
                tableVolumes.queryVolumesByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.volumeName = this.queryVolumesByGroupIdList[index].name
            },
            // 删除Volume
            deleteVolume: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除卷
                tableVolumes.$api.alertRuleExceptionResource.softDelete({
                    "ticketCompanyMonitorItemVariablesId":this.$route.query.id,
                    "resourceId":this.queryVolumesByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        tableVolumes.queryVolumesByGroupId();
                        this.isDisable = false;
                        this.volumeDelmodal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ebs/TableVolumes.vue